export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10353.f6ac3077.jpg";